const { combineReducers } = require('redux');
const { SIGNUP: Types, AUTH: AuthTypes, DATA_FETCHING } = require('../action-types');
const SignupDomain = require('../domain/signup');
const AuthConstants = require('services/auth-management/constants');
const AuthPersistence = require('services/auth-management/persistence');
const SignupState = require('services/auth-management/signup-state');

const internals = {};

internals.INVALID_SESSION_FAILURE_TYPES = new Set([
    DATA_FETCHING.FETCH_CURRENT_USER.FAILURE,
    DATA_FETCHING.FETCH_APP_ENTITIES.FAILURE,
    DATA_FETCHING.FETCH_NOTIFICATIONS.FAILURE
]);

internals.shouldClearInvalidSession = (action) => action?.error
    && internals.INVALID_SESSION_FAILURE_TYPES.has(action.type)
    && [401, 403].includes(action.payload?.error?.response?.status);

const signupContext = (state = AuthPersistence.getPersistedSignupContext(), action) => internals.shouldClearInvalidSession(action)
    && !state.verificationToken
    ? {}
    : SignupState.signupContextReducer({
        state,
        action,
        types: Types,
        authTypes: AuthTypes
    });

const identify = (state = AuthPersistence.getPersistedSignupStage({
    stage: AuthConstants.stages.identify.slice
}), action) => internals.shouldClearInvalidSession(action)
    ? {}
    : SignupState.signupIdentifyReducer({
        state,
        action,
        types: Types,
        authTypes: AuthTypes
    });

const authenticate = (state = AuthPersistence.getPersistedSignupStage({
    stage: AuthConstants.stages.authenticate.slice
}), action) => internals.shouldClearInvalidSession(action)
    ? {}
    : SignupState.signupAuthenticateReducer({
        state,
        action,
        types: Types,
        authTypes: AuthTypes
    });

const profile = (state = {}, action) => internals.shouldClearInvalidSession(action)
    ? {}
    : SignupState.signupProfileReducer({
        state,
        action,
        types: Types,
        authTypes: AuthTypes
    });

const signupCompleted = (state = false, action) => {

    if (internals.shouldClearInvalidSession(action)) {
        return false;
    }

    switch (action.type) {
        case Types.SIGNUP_COMPLETED:
            return true;
        case Types.CONTEXT_INIT:
        case Types.SCHOOL_CHECK.REQUEST:
        case AuthTypes.LOGIN.SUCCESS:
        case AuthTypes.LOGIN_TOKEN.SUCCESS:
        case AuthTypes.LOGOUT.SUCCESS:
        case AuthTypes.LOGOUT_SYNC:
        case AuthTypes.CLOSE_ACCOUNT.SUCCESS:
        case Types.COMPLETE.SUCCESS:
            return false;
        default:
            return state;
    }
};

const combinedReducer = combineReducers({
    context: signupContext,
    identify,
    authenticate,
    profile,
    signupCompleted
});

const reducer = (state, action) => {

    const verificationToken = action.payload?.request?.verificationToken;
    const isInviteResponse = [
        Types.AUTHENTICATE.CHECK_PASSWORD.SUCCESS,
        Types.PROFILE.FETCH_SIGNUP_PROGRESS.SUCCESS,
        Types.VERIFY_EMAIL.SUCCESS
    ].includes(action.type);

    if (isInviteResponse && verificationToken && verificationToken !== state?.context?.verificationToken) {
        return state || combinedReducer(undefined, { type: '@@INIT' });
    }

    return combinedReducer(state, action);
};

const selectors = {

    initPrerequisiteSatisfied: (state) => SignupState.isInitPrerequisiteSatisfied({
        signupDomain: SignupDomain,
        state
    }),

    authenticationPrerequisiteSatisfied: (state) => SignupState.isSignupAuthenticationPrerequisiteSatisfied({ state }),
    passwordPrerequisiteSatisfied: (state) => SignupState.isSignupPasswordPrerequisiteSatisfied({ state }),
    ssoPrerequisiteSatisfied: (state) => SignupState.isSignupSSOPrerequisiteSatisfied({ state }),
    userInfoPrerequisiteSatisfied: (state) => SignupState.isSignupAuthenticationPrerequisiteSatisfied({ state }),

    getSignupContext: SignupState.getSignupContext,
    getSignupIdentifyDetails: SignupState.getSignupIdentifyDetails,
    getSignupAuthenticateDetails: SignupState.getSignupAuthenticateDetails,
    getSignupCompleted: (state) => !!state.signupCompleted,
    getSignupProfileDetails: SignupState.getSignupProfileDetails,
    getSignupProfileInterests: SignupState.getSignupCompletionInterests,
    getSignupProfilePassionInterests: SignupState.getSignupCompletionPassionInterests,
    getSignupProfileRole: SignupState.getSignupCompletionRole,
    getSignupProfileRolePermissions: SignupState.getSignupCompletionRolePermissions,
    getSignupDetailsForCompletion: SignupState.getSignupDetailsForCompletion,










    getSignupProfileRolePermissions: SignupState.getSignupCompletionRolePermissions
};

module.exports = Object.assign(reducer, { selectors });
